import React, { useRef, useState, useCallback, useEffect } from 'react';
import { Card, Box, Grid, CardMedia, IconButton, Typography, CardActions,
  SpeedDial,Paper, Divider
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ScrollDialog from 'components/ScrollDialog';
import ImageResize from './ImageResize';
import { useSnackbar } from 'notistack';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import useConfirm from 'core/hooks/useConfirm';
import { getBannerImageFileNames, deleteBannerImage, uploadBannerImage } from 'services/settings/banner-images';

const BannerImagesPage = ({libraryId}) => {
  const [upImg, setUpImg] = useState();
  const fileInputRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [bannerImages, setBannerImages] = useState([]);
  const confirm = useConfirm();

  useEffect(() => {
    getBannerImages();
  }, []);

  function getBannerImages() {
    getBannerImageFileNames().then(({response, error}) => {
      if(response){
        setBannerImages([...(response || [])].map((image) => ({src: buildOtherPhotoUrl(image), name: image })))
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }
  
  // useEffect(() => {
  //   setBannerImages([...libraryPhotos.map((ele) => ({src: buildOtherPhotoUrl(ele), name: ele}))])
  //   return () => {};
  // }, [libraryPhotos]);

  const buildOtherPhotoUrl = (fileName) => {
    return `/rest/settings/images/banner/${fileName}`;
  }
  

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
      clearImageSelection();
    },
    [],
  );

  const ShowModal = () => {
    // event.preventDefault();
    setOpenModal(true);
  }

  const closeModal = () => {
    setOpenModal(false);
    clearImageSelection();
  }

  const clearImageSelection = () => {
    setUpImg(null);
    fileInputRef.current.value="";
  }

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        //Initiate the JavaScript Image object.
        const image = new Image();

        //Set the Base64 string return from FileReader as source.
        image.src = reader.result;

        //Validate the File Height and Width.
        image.onload = (e) => {
          var height = image.height;
          var width = image.width;
          if (height < 768 || width < 1366) {
            enqueueSnackbar("Image should be atleast 768px height and 1366px width", {variant: 'error'});
            return false;
          }
          setUpImg(reader.result);
          ShowModal();
          return true;
        };
        
      });
      reader.readAsDataURL(e.target.files[0]);
    }
  };


  const selectBannerImage = () => {
    selectImage();
  }
  
  const selectImage = () => {
    fileInputRef.current.click();
  }

  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type:mime});
  }

  const uploadBannerImages = (imgSrc) => {
    uploadBannerImage({ 
      image: dataURLtoFile(imgSrc, 'other-image.jpg'), 
      libraryId 
    }).then(({response, error}) => {
      if(response){
        setBannerImages([...bannerImages, { src: buildOtherPhotoUrl(response.fileName), name: response.fileName }])
        enqueueSnackbar("Image uploaded successfully", {variant: 'success'});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
        clearImageSelection()
      }
    });
  }

  const uploadFile = useCallback((img) => {
    const imgSrc = img.src;
    uploadBannerImages(imgSrc);
    closeModal();
  }, [bannerImages]);

  const onPhotoDelete = (imageIndex) => {
    confirm({ title: 'Delete Photo?', description: 'Are you sure you want to delete this photo?' })
    .then(() => { 
      deleteBannerPhoto(imageIndex);
    }).catch((e) => {})
  }

  const deleteBannerPhoto = (imageIndex) => {
    const temp = [...bannerImages];
    const [deletedItem] = temp.splice(imageIndex, 1);

    deleteBannerImage({ 
      fileName: deletedItem.name, 
    }).then(({response, error}) => {
      if(response){
        setBannerImages([...temp]);
        enqueueSnackbar("Image deleted successfully", {variant: 'success'});
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });

  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Banner Images
      </Typography>
      <Divider />
      <Box sx={{ mb: 2, mt:2, px: 4, }} >
        <Grid container columnSpacing={2} >
          {bannerImages.map((ele, i) => (
            <Grid item xs={12} sm={12} md={6} lg={4} sx={{mb: 3}} key={i}>
              <Card sx={{  position: 'relative' }}>
              <CardMedia
                component="img"
                height="196"
                image={ele.src}
              />
              {/* <CardContent >
                <Typography  variant="p" component="div">
                  Cover Photo
                </Typography>
              </CardContent> */}
              <CardActions sx={{ position: 'absolute', bottom: 0, right: 0}}>
                <IconButton variant="raised" sx={{
                  borderRadius: '50%', background: '#f3f3f3', color: '#a51414',
                  "&.MuiButtonBase-root:hover": {
                    bgcolor: "#f3f3f3"
                  }
                  }}  onClick={() => onPhotoDelete(i)}
                >
                  <DeleteForeverIcon />
                </IconButton>
              </CardActions>
            </Card>
            </Grid>
          ))}
        </Grid>
        <SpeedDial
          onClick={selectBannerImage}
          ariaLabel="Add Image"
          sx={{ position: 'absolute', bottom: 75, right: 75 }}
          icon={<AddIcon />}
        />
        <input type="file" accept="image/*" ref={fileInputRef} onChange={onSelectFile} style={{display: 'none'}} />
        <ScrollDialog maxWidth="xl" onModalClose={onModalClose} open={openModal} title="Image Upload">
          <ImageResize upImg={upImg} uploadFile={uploadFile} />
        </ScrollDialog>
      </Box>
    </Paper>
  );
}
 
export default React.memo(BannerImagesPage);
